<ngx-ui-loader [loaderId]="'alert'"></ngx-ui-loader>
<div *ngIf="isAlertTable">
    <div class="row">
        <div class="col-md-6">
            <mat-form-field class="form-element" style="width: 100%;">
                <mat-label>Select Feeder</mat-label>
                <mat-select [(value)]="displayedFeeder">
                    <mat-option *ngFor="let option of displayedOptions" [value]="option" (click)="changeFeeder(option)">
                        {{option}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <!-- Time Filter Select -->
            <mat-form-field class="form-element" style="width: 100%;">
                <mat-label>Duration </mat-label>
                <mat-select [(value)]="selectedDuration">
                    <mat-option  *ngFor="let time of timeOptions" [value]="time" (click)="changeDate(time)" >
                        {{time}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <mat-card style="padding: 0px;">
        <mat-card-header style="background-color:red; justify-content: center; align-items: center;">
            <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF; text-align: center;">Live Alerts</b>
        </mat-card-header>
        <mat-card-content style="height:auto;overflow: auto;scroll-behavior: smooth;padding-right: 3px;padding-left: 3px;padding-bottom: 3px;">
            <ng-container>
                <table class="alerts-table" id="alerttabledata" *ngIf ="isAlertData else noData" >
                    <thead>
                        <tr style=" width: fit-content;  position: sticky; top:0">
                            <th>Date</th>
                            <th>Time</th>
                            <th>SwitchID</th>
                            <th>Parameter</th>
                            <th>Actual Value</th>
                            <th>Threshold Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="scrolling-text" *ngFor="let arr of feederAlertData">
                            <td>{{arr.dateFormat}}</td>
                            <td>{{arr.time}}</td>
                            <td>{{arr.switchGearID}}</td>
                            <td> {{arr.paramName}} </td>
                            <td> {{arr.actualValue}} </td>
                            <td> {{arr.thresholdValue}} </td>
                        </tr>
                    </tbody>
                </table>
                <ng-template #noData>
                    <div style="font-size: 1.5em;text-align: center;width:100%;display: block;">
                        Alerts Not Generated.<br>
                        <img src="../assets/images/warning.gif" alt="Warning" style="height: 30vh;">
                    </div>
                </ng-template>
            </ng-container>
        </mat-card-content>
    </mat-card>
</div>

<ngx-ui-loader [loaderId]="'gateway'"></ngx-ui-loader>
<div *ngIf="isGatewayTable">
    <div class="row">
        <div class="col-md-6">
            <mat-form-field class="form-element" style="width: 100%;">
                <mat-label>Select Feeder</mat-label>
                <mat-select [(value)]="displayedFeeder">
                    <mat-option *ngFor="let option of displayedOptions" [value]="option" (click)="changeGatewayFeeder(option)">
                        {{option}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <!-- Time Filter Select -->
            <mat-form-field class="form-element" style="width: 100%;">
                <mat-label>Duration </mat-label>
                <mat-select [(value)]="selectedDuration">
                    <mat-option  *ngFor="let time of timeOptions" [value]="time" (click)="changeGatewayDate(time)" >
                        {{time}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row modal-title" id="exampleModalLabel">
        <div class="col-md-6">
        <mat-form-field  style="margin-right: auto;" fxFlex="40%" style="width: 80%;">
            <input matInput type="text" (keyup)="doFilter($event.target.value)" placeholder="Search">
        </mat-form-field>
        </div>
        <div class="col-md-6">
            <b>Download In:</b>&nbsp;<button style="margin-left: 2%;"  mat-button (click)="exporter.exportTable('xlsx',{fileName:'Report'})"><img src="../../assets/images/icons8-microsoft-excel-30.png">
                </button>
        </div>
    </div>

    <mat-card style="padding: 0px;">
        <mat-card-header style="background-color:red; justify-content: center; align-items: center;">
            <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF; text-align: center;">Gateway Report</b>
        </mat-card-header>
        <mat-card-content style="height:auto;overflow: auto;scroll-behavior: smooth;padding-right: 3px;padding-left: 3px;padding-bottom: 3px;">
            <ng-container>
                <table mat-table matTableExporter [dataSource]="dataSource" #exporter="matTableExporter"  matSort class="example-container" >

                    <!-- Dynamic Column Definitions -->
                    <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header style="background-color: orange; font-weight: bold; font-size: large;">{{ column }}</th>
                      <td mat-cell *matCellDef="let element">
                        <!-- Check if the column is a nested key -->
                        <span *ngIf="element[column] !== undefined">{{ element[column] }}</span>
                        <span *ngIf="element.data && element.data[column] !== undefined">{{ element.data[column] }}</span>
                      </td>
                    </ng-container>
              
                    <!-- Header and Row Declarations -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              
                  </table>
                  <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons></mat-paginator>
               <!-- <ng-template #noData>
                    <div style="font-size: 1.5em;text-align: center;width:100%;display: block;">
                        Gateway Report Has No Data. <br>
                        <img src="../assets/images/warning.gif" alt="Warning" style="height: 30vh;">
                    </div>
                </ng-template> -->
            </ng-container>
        </mat-card-content>
    </mat-card>


    <!--HTML CODE FOR GATEWAY AFTER THE CALLS HAVE BEEN MADE IN TS FILE (SIMILAR TO SWITCH)-->

</div>
